const PAGINATION_COUNT = "pagination-count";
const PAGINATION_LIMIT = "pagination-limit";
const PAGINATION_PAGE = "pagination-page";

export {
    PAGINATION_COUNT,
    PAGINATION_LIMIT,
    PAGINATION_PAGE
}
